import { useMutation, useQuery } from "@tanstack/react-query";
import { useSyncExternalStore } from "react";

import {
  accountsApiLegacyGoogleLoginMutation,
  accountsApiProfileGetCurrentUserOptions,
} from "@/api-client/@tanstack/react-query.gen";
import {
  getAuthStatus,
  isSignedIn,
  setAuthStatus,
  subscribeToAuthStatus,
} from "@/features/auth/session/auth-status";
import { queryClient } from "@/lib/query-client";

import type { AuthResponse } from "@/features/auth/types";

export function useAuthStatus() {
  return useSyncExternalStore(subscribeToAuthStatus, getAuthStatus);
}

export function useCurrentUser() {
  const authStatus = useAuthStatus();
  return useQuery({
    ...accountsApiProfileGetCurrentUserOptions(),
    enabled: isSignedIn(authStatus),
    retry: false,
    staleTime: Infinity,
  });
}

export function useGoogleLogin() {
  return useMutation({
    ...accountsApiLegacyGoogleLoginMutation(),
    onSuccess: (data) => {
      queryClient.setQueryData(accountsApiProfileGetCurrentUserOptions().queryKey, data);
      setAuthStatus("legacy");
    },
  });
}

export function loginMock(): Promise<AuthResponse> {
  return Promise.resolve({
    user: {
      id: "mock-id",
      email: "demo@nextretail.ai",
      first_name: "Demo",
      last_name: "User",
    },
    employee: {
      employee_id: "mock-employee",
      retailer_id: "f56f893f-7670-4e26-9291-954c1cf35dc9",
      role: "COORDINATOR",
    },
  });
}
